var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

import React from "react";
import { STYLE_TYPE } from "../../../config/constants";
import blockHTML from "../../../utils/blockHTML";

export var styleToHTML = function styleToHTML(style) {
  switch (style.toLowerCase()) {
    case STYLE_TYPE.BOLD:
      return React.createElement("strong", null);

    case STYLE_TYPE.ITALIC:
      return React.createElement("em", null);

    default:
      return React.createElement("span", null);
  }
};

export var blockToHTML = function blockToHTML(extras, isClient) {
  return function (block) {
    var html = blockHTML[block.type.toLowerCase()];

    switch (typeof html === "undefined" ? "undefined" : _typeof(html)) {
      case "undefined":
        return blockHTML["default"];

      case "function":
        return html(block, extras, isClient);

      default:
        return html;
    }
  };
};


// WEBPACK FOOTER //
// ./src/components/Library/StoryBody/conversionHelpers.js